import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import Styles from './TemplateSelect.module.scss'
import { forwardRef } from 'react'
import { VisualElement } from 'api/clients/VisualElementClient'
import { BrandVisualKit } from 'types'
import { useObjectRef } from '@react-aria/utils'
import { getTemplatePreviewCloudinaryUrl } from 'components/Design/utils/getTemplatePreviewCloudinaryUrl'
import { useCarouselPress } from 'components/Carousel/useCarouselPress'
import { Pressable } from '@react-aria/interactions'
import { WIDE_ASPECT_RATIO } from './TemplateSelect'
import { TemplatesVideoIcon } from 'components/Templates/TemplatesVidoIcon/TemplatesVideoIcon'

interface Props {
  template: VisualElement
  brandVisualKit?: BrandVisualKit
  onPress: () => void
  aspectRatio: number
  isSelected?: boolean
  itemWidth?: number
  itemHeight?: number
  grow?: boolean
  growHeight?: boolean
  largePreview?: boolean
  isDisabled?: boolean
  borderRadius?: number | string
}

export const TemplatePreview = observer(
  forwardRef<HTMLDivElement, Props>(
    (
      {
        template,
        onPress,
        isSelected = false,
        aspectRatio,
        itemWidth,
        itemHeight,
        grow,
        growHeight,
        largePreview,
        isDisabled = false,
        borderRadius,
      },
      fRef,
    ) => {
      const ref = useObjectRef(fRef)
      const { pressProps, ...rest } = useCarouselPress({ onPress, isDisabled })
      const isWide = aspectRatio > WIDE_ASPECT_RATIO

      const url = getTemplatePreviewCloudinaryUrl(template.preview_url, { height: itemHeight, width: itemWidth })

      return (
        <Pressable {...pressProps}>
          <div
            className={cx(Styles.templatePreview, {
              [Styles.selected]: isSelected,
              [Styles.wide]: aspectRatio > 1.5,
              [Styles.grow]: grow,
              [Styles.growHeight]: growHeight,
              [Styles.large]: largePreview,
              [Styles.isDisabled]: isDisabled,
            })}
            ref={ref}
            {...rest}
            role="button"
            tabIndex={0}
            aria-label={`Select template: ${template.name}`}
            style={{ aspectRatio, borderRadius }}
          >
            <img key={template.id} src={url} alt={template.name} className={cx({ [Styles.wide]: isWide })} />
            {template.types.includes('video') && <TemplatesVideoIcon />}
          </div>
        </Pressable>
      )
    },
  ),
)
